export default "<app-signature></app-signature>";